export default __webpack_public_path__ + "static/media/45.b2ac3417.jpeg";